import { useState, type FormEvent } from 'react'

import { useAuth } from '../../auth/AuthProvider'
import { AuthShell } from './AuthShell'

type LoginScreenProps = {
  onRegister: () => void
  onForgot: () => void
}

export const LoginScreen = ({ onRegister, onForgot }: LoginScreenProps) => {
  const { login } = useAuth()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [submitting, setSubmitting] = useState(false)

  const openPreview = () => {
    const params = new URLSearchParams(window.location.search)
    params.set('preview', '1')
    window.location.search = params.toString()
  }

  const onSubmit = async (event: FormEvent) => {
    event.preventDefault()
    setError(null)
    setSubmitting(true)
    try {
      await login(email, password)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Не удалось войти')
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <AuthShell title="Вход">
      <form className="pwa-auth__form" onSubmit={onSubmit}>
        <label className="echat-field">
          <span className="echat-field__label">Email или логин</span>
          <input
            className="echat-field__input"
            type="text"
            autoComplete="username"
            inputMode="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </label>
        <label className="echat-field">
          <span className="echat-field__label">Пароль</span>
          <input
            className="echat-field__input"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </label>

        {error ? (
          <p className="echat-error" role="alert">
            {error}
          </p>
        ) : null}

        <button
          className="echat-btn echat-btn--primary"
          type="submit"
          disabled={submitting || !email.trim() || !password}
        >
          {submitting ? 'Входим…' : 'Войти'}
        </button>
      </form>

      <div className="pwa-auth__links">
        <button type="button" className="pwa-auth__link" onClick={onForgot}>
          Забыли пароль?
        </button>
        <button type="button" className="pwa-auth__link" onClick={onRegister}>
          Регистрация
        </button>
      </div>

      <p className="pwa-auth__demo">
        <button type="button" className="pwa-auth__link" onClick={openPreview}>
          Открыть демо кабинет
        </button>
      </p>
    </AuthShell>
  )
}
